import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePhasrRecommendationsGrid = document.createElement('template');

templatePhasrRecommendationsGrid.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <div class='wrapper'>
    <div class='phasr-recommendations-grid-content'>
      <div class='phasr-recommendations-grid'>
        <gz-grid-view showGlobalActions>
        </gz-grid-view>
      </div>
    </div>
  </div>
  <gz-side-menu id='behavioralProfilesPanel' menuwidth='400' closeOnClickOutside>
  </gz-side-menu>
  <gz-side-menu id='recommendationDetailsPanel' menuwidth='400' closeOnClickOutside>
  </gz-side-menu>
`;
